import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cookie-banner',
  template: `
    <div *ngIf="!accepted" class="cookie-banner">
      <div class="cookie-content">
        <p>
          This website uses cookies only for the purpose of providing the document digitization service. 
          Irisel Consulting S.L.U. acts as service provider and, regarding invoice data processed within the platform, acts as a Data Processor under the GDPR.

          You can review our Privacy Policy and Terms of Service at:
          https://www.irisel.com/index.php/en/about
       
          <strong>Irisel Consulting S.L.U.</strong> (C.I.F. B-85138253), 
          Av. Industria 29A - 28760 Tres Cantos, Madrid (Spain).
        </p>
        <p>
          Company registered in the Mercantile Registry of Madrid, volume 24.435, folio 146, section 8, Sheet M-439546.
          © Irisel Consulting. 2007 - 2025. Spain. All rights reserved.
        </p>
        <div class="cookie-actions">
          <button class="btn-accept" (click)="acceptCookies()">Accept</button>
          <button class="btn-reject" (click)="rejectCookies()">Reject</button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .cookie-banner {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      background: #2c3e50;
      color: white;
      padding: 1rem;
      z-index: 1000;
      box-shadow: 0 -2px 10px rgba(0,0,0,0.2);
    }
    
    .cookie-content {
      max-width: 1200px;
      margin: 0 auto;
      font-size: 0.9rem;
      line-height: 1.4;
    }
    
    .cookie-content p {
      margin: 0.5rem 0;
    }
    
    .cookie-actions {
      margin-top: 1rem;
      display: flex;
      gap: 1rem;
    }
    
    .btn-accept, .btn-reject {
      padding: 0.5rem 1.5rem;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-weight: 500;
    }
    
    .btn-accept {
      background: #3498db;
      color: white;
    }
    
    .btn-accept:hover {
      background: #2980b9;
    }
    
    .btn-reject {
      background: #e74c3c;
      color: white;
    }
    
    .btn-reject:hover {
      background: #c0392b;
    }
  `]
})
export class CookieBannerComponent implements OnInit {
  accepted = false;

  ngOnInit() {
    // Check if user has already accepted cookies
    const cookieAccepted = localStorage.getItem('cookieAccepted');
    this.accepted = cookieAccepted === 'true';
  }

  acceptCookies() {
    localStorage.setItem('cookieAccepted', 'true');
    this.accepted = true;
  }

  rejectCookies() {
    localStorage.setItem('cookieAccepted', 'false');
    this.accepted = true; // Hide banner after rejection
    // Optionally, you could clear existing cookies here
    // this.clearCookies();
  }

  private clearCookies() {
    // Clear all cookies (except essential ones)
    document.cookie.split(";").forEach(cookie => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      // Don't clear essential cookies like job_uuid_*
      if (!name.startsWith('job_uuid_')) {
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      }
    });
  }
}